import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminEmailsComponent } from './admin-emails.component';
import { ConstantsRotasDoSistema } from '../../shared/constants/constants-rotas-do-sistema';
import { AuthGuardService } from '../../shared/services/auth.service';

const routes: Routes = [
    {
        path: ConstantsRotasDoSistema.ADMIN_EMAILS,
        canActivate: [AuthGuardService],
        children: [
            {
                path: '',
                component: AdminEmailsComponent
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AdminEmailsRoutingModule {}
